import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-65bb07f9"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "box-profile" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { class: "input-item" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "email" }, "Email", -1))
const _hoisted_5 = ["value"]
const _hoisted_6 = { class: "input-item" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "username" }, "Name", -1))
const _hoisted_8 = { class: "input-item" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "website" }, "Website", -1))
const _hoisted_10 = ["value", "disabled"]
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_12 = ["disabled"]
const _hoisted_13 = { key: 1 }
const _hoisted_14 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.showForm)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("form", {
            class: "form-widget",
            onSubmit: _cache[2] || (_cache[2] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.updateProfile && _ctx.updateProfile(...args)), ["prevent"]))
          }, [
            _createElementVNode("div", _hoisted_3, [
              _hoisted_4,
              _createElementVNode("input", {
                class: "input-text",
                id: "email",
                type: "text",
                value: _ctx.userEmail,
                disabled: ""
              }, null, 8, _hoisted_5)
            ]),
            _createElementVNode("div", _hoisted_6, [
              _hoisted_7,
              _withDirectives(_createElementVNode("input", {
                class: "input-text",
                id: "username",
                type: "text",
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.username) = $event))
              }, null, 512), [
                [_vModelText, _ctx.username]
              ])
            ]),
            _createElementVNode("div", _hoisted_8, [
              _hoisted_9,
              _withDirectives(_createElementVNode("input", {
                class: "input-text",
                id: "website",
                type: "website",
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.website) = $event))
              }, null, 512), [
                [_vModelText, _ctx.website]
              ])
            ]),
            _createElementVNode("div", null, [
              _createElementVNode("input", {
                type: "submit",
                class: "btn btn-primary",
                value: _ctx.loading ? 'Loading ...' : 'Update Information',
                disabled: _ctx.loading
              }, null, 8, _hoisted_10)
            ])
          ], 32),
          _hoisted_11,
          _createElementVNode("div", null, [
            _createElementVNode("button", {
              class: "btn btn-danger",
              onClick: _cache[3] || (_cache[3] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.signOut && _ctx.signOut(...args)), ["prevent"])),
              disabled: _ctx.loading
            }, " Sign Out ", 8, _hoisted_12)
          ])
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_13, [
          _createTextVNode(" Loading... "),
          _createElementVNode("button", {
            class: "button-30",
            onClick: _cache[4] || (_cache[4] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.signOut && _ctx.signOut(...args)), ["prevent"])),
            disabled: _ctx.loading
          }, " Sign Out ", 8, _hoisted_14)
        ]))
  ]))
}